"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandFlag = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const flora_react_1 = require("@grupoboticario/flora-react");
const images_1 = require("../../utils/images");
const brand_1 = require("../../utils/lang/brand");
function BrandFlag({ businessUnit }) {
    const brandName = brand_1.BRAND_TEXTS[businessUnit].nameWithPrefix;
    const brandImage = Object.keys(images_1.brandFlagImages).includes(businessUnit)
        ? images_1.brandFlagImages[businessUnit]
        : undefined;
    if (!brandImage)
        return null;
    return ((0, jsx_runtime_1.jsx)(flora_react_1.Box, { as: "img", css: { height: 'calc($4 * 2.375)', width: 'calc($4 * 2.125)' }, src: brandImage, alt: `Logo d${brandName}` }));
}
exports.BrandFlag = BrandFlag;
